import { useMutation, useQuery } from "@tanstack/react-query";
import { buildPushNotificationsRegisterMutation } from "../hooks/buildPushNotificationsRegisterMutation";
import { useEffect } from "react";
import { getCurrentUserQueryOptions } from "@/users/operations/get-current-user/getCurrentUserQueryOptions";
import { buildPushNotificationsPermissionsQuery } from "../hooks/buildPushNotificationsPermissionsQuery";
import { useLogger } from "@/logging/client/LoggerContext";

// This component is used to re-register the push notifications when the user logs in.
// This is necessary because the token can change sometimes, and we need to re-register the device.
export function PushNotificationsReRegisterer() {
	const registerMutation = useMutation(
		buildPushNotificationsRegisterMutation(),
	);
	const userQuery = useQuery(getCurrentUserQueryOptions());

	const permissionsQueryOptions = buildPushNotificationsPermissionsQuery();
	const permissionsQuery = useQuery({
		...permissionsQueryOptions,
		enabled: !!permissionsQueryOptions.enabled && !!userQuery.data,
	});

	const logger = useLogger();

	useEffect(() => {
		if (permissionsQuery.data?.receive === "granted") {
			registerMutation.mutate(undefined, {
				onError: (e) => {
					logger.error(`Push Notifications Re-Register Mutation Error: ${e}`);
				},
			});
		} else if (permissionsQuery.data) {
			logger.info(
				`Push Notifications Re-Register Permission Not Granted: ${permissionsQuery.data?.receive}`,
			);
		}
	}, [permissionsQuery.data]);

	useEffect(() => {
		if (permissionsQuery.error) {
			logger.error(
				`Push Notifications Re-Register Permissions Error: ${permissionsQuery.error}`,
			);
		}
	}, [permissionsQuery.error]);

	return null;
}
